const cardAdd = () => import('@/views/main/card/add/add.vue')
export default {
  path: '/main/card/add',
  name: 'cardAdd',
  component: cardAdd,
  children: []
}
